import { memoize } from 'lodash';
import { parseModel } from 'lbs-pi-platform-access/es/utils/model-builders';
import { stripLeadingAtSign } from 'uScope/js/lib/utility/helpers';

/**
 * Converts a region as defined in uScope/Annotations/Region to a more structured object, consistent with that provided
 * by platform/data/annotations/region
 * @param legacyRegion
 * @returns {*}
 */
export const translateRegion = memoize(function (legacyRegion) {
  if (!legacyRegion) {
    return null;
  }

  return parseModel(legacyRegion, {
    id: {type: Number, path: 'regionId'},
    displayId: {type: Number, path: 'displayId'},
    note: {type: String, path: 'note'},
    type: {type: Number, path: 'type'},
    zoom: {type: Number, path: 'zoom'},
    layerId: {type: Number, path: 'layerId'},
    imageId: {type: ImageId, path: 'imageId'},
    inputRegionId: {type: Number, path: 'InputRegionId'},
    markupImageId: {type: Number, path: 'MarkupImageId'}
  });
}, (r) => r && r.regionId);

/**
 * Converts a region as defined in uScope/Annotations/Layer to a more structured object, consistent with that provided
 * by platform/data/annotations/layer
 * @param legacyLayer
 * @returns {*}
 */
export const translateLayer = memoize(function (legacyLayer) {
  if (!legacyLayer) {
    return null;
  }

  const layer = parseModel(legacyLayer, {
    id: {type: Number, path: 'model.Id'},
    type: {type: Number, path: 'model.Type'},
    name: {type: String, path: 'model.Name'},
    isSelected: {type: Boolean, path: 'model.Selected'},
    isReadOnly: {type: Boolean, path: 'model.ReadOnly'},
    isNameReadOnly: {type: Boolean, path: 'model.NameReadOnly'},
    isLineColorReadOnly: {type: Boolean, path: 'model.LineColorReadOnly'},
    isIncremental: {type: Boolean, path: 'model.Incremental'},
    lineColor: {type: Number, path: 'model.LineColor'},
    isVisible: {type: Boolean, path: 'model.Visible'},
    imageId: {type: Number, path: 'model.ImageId'},
    macroName: {type: String, path: 'model.MacroName'},
    macroId: {type: Number, path: 'model.MacroId'},
    inputAnnotationId: {type: Number, path: 'model.InputAnnotationId'}
  });

  layer.regions = [];

  return layer;
}, (l) => l && l.get('Id'));

/**
 * @return {number}
 */
export function ImageId (num) {
  if (Number.isInteger(num)) {
    return Number(num);
  } else {
    return Number(stripLeadingAtSign(num));
  }
}



// WEBPACK FOOTER //
// ./src/shared/stores/annotations/legacy-translations.js